module.exports = __webpack_public_path__ + "static/media/websites.9fbc9fb5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/websites.jpg
// module id = 798
// module chunks = 5